import { EventEmitter } from '@angular/core';
import { DateFormatPipe } from '@app/shared/pipes/moment/date-format.pipe';
import { DynamcColumnComponent } from '@app/shared';

export class CalendarConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor () {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'Actualmente no hay historial',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        tramite_expediente: {
          title: 'Consecutivo del sistema',
          editable: false,
        },
        tramite_radicado_solicitud: {
          title: 'Radicado de solicitud',
          editable: false,
        },
        tramite_radicado_expediente: {
          title: 'Expediente',
          editable: false,
        },
        nombre_tramite: {
          title: 'Trámite',
          editable: false,
        },
        actividad: {
          title: 'Actividad',
          editable: false,
        },
        nombre: {
          title: 'Tarea',
          editable: false,
        },
        fecha_activacion: {
          title: 'Fecha de asignación',
          editable: false,
          sortDirection: 'desc',
          valuePrepareFunction: (cell: any, row: any) => {
            const formatted = new DateFormatPipe().transform(row.fecha_activacion);
            return formatted;
          }
        },
      },
    };
  }

  /**
   * Genera las columnas dinamicas del calendario de actividades
   *
   * @param {string} key
   * @param {string} title
   * @memberof CalendarConfig
   */
  generateColumn(key: string, title: string) {
    this.settings['columns'][key] = {
      title: title,
      editable: false,
      type: 'custom',
      renderComponent: DynamcColumnComponent,
      onComponentInitFunction() {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/shared/calendar.config.service.ts